var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 56V50.6667C45.8334 47.8377 44.7096 45.1246 42.7092 43.1242C40.7088 41.1238 37.9957 40 35.1667 40H13.8334C11.0044 40 8.29133 41.1238 6.29094 43.1242C4.29055 45.1246 3.16675 47.8377 3.16675 50.6667V56",
    stroke: "#D6DAE0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 29.3333C30.3912 29.3333 35.1668 24.5577 35.1668 18.6667C35.1668 12.7756 30.3912 8 24.5002 8C18.6091 8 13.8335 12.7756 13.8335 18.6667C13.8335 24.5577 18.6091 29.3333 24.5002 29.3333Z",
    stroke: "#D6DAE0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8334 56V50.6667C61.8316 48.3033 61.045 46.0074 59.597 44.1395C58.149 42.2716 56.1217 40.9375 53.8334 40.3467",
    stroke: "#D6DAE0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 8.34668C45.4612 8.93415 47.4948 10.2685 48.9471 12.1395C50.3994 14.0105 51.1877 16.3116 51.1877 18.68C51.1877 21.0485 50.3994 23.3496 48.9471 25.2205C47.4948 27.0915 45.4612 28.4259 43.1667 29.0133",
    stroke: "#D6DAE0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.69effd19749079043dfe372dbeb8277f.svg";
export { ForwardRef as ReactComponent };